module.exports = {
	"v": "4.8.0",
	"fr": 29.9700012207031,
	"ip": 0,
	"op": 720.000029326201,
	"w": 1920,
	"h": 1080,
	"nm": "_typo 2",
	"ddd": 0,
	"assets": [
		{
			"id": "comp_0",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 0,
					"nm": "E",
					"refId": "comp_1",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								1399,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 0,
					"nm": "C",
					"refId": "comp_2",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								725,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 0,
					"nm": "A",
					"refId": "comp_3",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								715,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Curves",
							"mn": "ADBE CurvesCustom",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 7,
									"nm": "Channel:",
									"mn": "ADBE CurvesCustom-0002",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 1
									}
								},
								{}
							]
						}
					],
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 0,
					"nm": "F",
					"refId": "comp_4",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								705,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Curves",
							"mn": "ADBE CurvesCustom",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 7,
									"nm": "Channel:",
									"mn": "ADBE CurvesCustom-0002",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 1
									}
								},
								{}
							]
						}
					],
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 0,
					"nm": "R",
					"refId": "comp_5",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								697,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Curves",
							"mn": "ADBE CurvesCustom",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 7,
									"nm": "Channel:",
									"mn": "ADBE CurvesCustom-0002",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 1
									}
								},
								{}
							]
						}
					],
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 6,
					"ty": 0,
					"nm": "E",
					"refId": "comp_1",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								687,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Curves",
							"mn": "ADBE CurvesCustom",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 7,
									"nm": "Channel:",
									"mn": "ADBE CurvesCustom-0002",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 1
									}
								},
								{}
							]
						}
					],
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 7,
					"ty": 0,
					"nm": "P",
					"refId": "comp_6",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								677,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Curves",
							"mn": "ADBE CurvesCustom",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 7,
									"nm": "Channel:",
									"mn": "ADBE CurvesCustom-0002",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 1
									}
								},
								{}
							]
						}
					],
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 8,
					"ty": 0,
					"nm": "U",
					"refId": "comp_7",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								669,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Curves",
							"mn": "ADBE CurvesCustom",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 7,
									"nm": "Channel:",
									"mn": "ADBE CurvesCustom-0002",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 1
									}
								},
								{}
							]
						}
					],
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 9,
					"ty": 0,
					"nm": "S",
					"refId": "comp_8",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								657,
								301.5,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"ef": [
						{
							"ty": 5,
							"nm": "Curves",
							"mn": "ADBE CurvesCustom",
							"ix": 1,
							"en": 1,
							"ef": [
								{
									"ty": 7,
									"nm": "Channel:",
									"mn": "ADBE CurvesCustom-0002",
									"ix": 1,
									"v": {
										"a": 0,
										"k": 1
									}
								},
								{}
							]
						}
					],
					"w": 1920,
					"h": 1080,
					"ip": 0,
					"op": 601.000024479232,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_1",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "E",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 32,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 119.000004846969
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-55.414,
																71.132
															],
															[
																56.413,
																71.174
															],
															[
																56.413,
																71.247
															],
															[
																-55.452,
																71.122
															],
															[
																-55.452,
																1.927
															],
															[
																44.104,
																1.177
															],
															[
																44.354,
																1.125
															],
															[
																-55.186,
																1.875
															],
															[
																-55.452,
																1.516
															],
															[
																-55.327,
																-71.122
															],
															[
																56.538,
																-70.997
															],
															[
																56.413,
																-71.049
															],
															[
																-55.414,
																-71.091
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.414,
																71.799
															],
															[
																56.413,
																71.799
															],
															[
																56.413,
																69.747
															],
															[
																-53.952,
																69.747
															],
															[
																-53.952,
																2.052
															],
															[
																44.104,
																2.052
															],
															[
																44.104,
																0
															],
															[
																-52.311,
																0
															],
															[
																-53.952,
																1.641
															],
															[
																-53.952,
																-69.747
															],
															[
																56.413,
																-69.747
															],
															[
																56.413,
																-71.799
															],
															[
																-56.414,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.198,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.414,
																71.799
															],
															[
																56.413,
																71.799
															],
															[
																56.413,
																69.747
															],
															[
																-53.952,
																69.747
															],
															[
																-53.952,
																2.052
															],
															[
																44.104,
																2.052
															],
															[
																44.104,
																0
															],
															[
																-52.311,
																0
															],
															[
																-53.952,
																1.641
															],
															[
																-53.952,
																-69.747
															],
															[
																56.413,
																-69.747
															],
															[
																56.413,
																-71.799
															],
															[
																-56.414,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.414,
																71.799
															],
															[
																56.413,
																71.799
															],
															[
																56.419,
																55.622
															],
															[
																-40.946,
																55.659
															],
															[
																-40.936,
																8.464
															],
															[
																44.12,
																8.427
															],
															[
																44.051,
																-7.125
															],
															[
																-26.364,
																-7.142
															],
															[
																-40.936,
																7.303
															],
															[
																-40.936,
																-55.46
															],
															[
																56.429,
																-55.497
															],
															[
																56.413,
																-71.799
															],
															[
																-56.414,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.398,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.414,
																71.799
															],
															[
																56.413,
																71.799
															],
															[
																56.419,
																55.622
															],
															[
																-40.946,
																55.659
															],
															[
																-40.936,
																8.464
															],
															[
																44.12,
																8.427
															],
															[
																44.051,
																-7.125
															],
															[
																-26.364,
																-7.142
															],
															[
																-40.936,
																7.303
															],
															[
																-40.936,
																-55.46
															],
															[
																56.429,
																-55.497
															],
															[
																56.413,
																-71.799
															],
															[
																-56.414,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.414,
																71.799
															],
															[
																56.413,
																71.799
															],
															[
																56.315,
																31.372
															],
															[
																-16.05,
																31.301
															],
															[
																-16.029,
																20.106
															],
															[
																44.026,
																20.177
															],
															[
																43.944,
																-20.375
															],
															[
																1.217,
																-20.528
															],
															[
																-15.967,
																17.924
															],
															[
																-16.029,
																-31.568
															],
															[
																56.336,
																-31.497
															],
															[
																56.413,
																-71.799
															],
															[
																-56.414,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.599,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.414,
																71.799
															],
															[
																56.413,
																71.799
															],
															[
																56.315,
																31.372
															],
															[
																-16.05,
																31.301
															],
															[
																-16.029,
																20.106
															],
															[
																44.026,
																20.177
															],
															[
																43.944,
																-20.375
															],
															[
																1.217,
																-20.528
															],
															[
																-15.967,
																17.924
															],
															[
																-16.029,
																-31.568
															],
															[
																56.336,
																-31.497
															],
															[
																56.413,
																-71.799
															],
															[
																-56.414,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.414,
																71.799
															],
															[
																56.413,
																71.799
															],
															[
																56.316,
																31.372
															],
															[
																56.201,
																31.386
															],
															[
																56.033,
																61.996
															],
															[
																107.776,
																62.177
															],
															[
																107.694,
																-61.375
															],
															[
																55.967,
																-60.778
															],
															[
																55.908,
																17.689
															],
															[
																56.221,
																-31.483
															],
															[
																56.336,
																-31.497
															],
															[
																56.413,
																-71.799
															],
															[
																-56.414,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											543.091,
											333.903
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 1.00000004073083,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_2",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 2",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								1480.875,
								564.875,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								520.875,
								25.125,
								0
							]
						},
						"s": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833,
											0.833,
											0.833
										],
										"y": [
											0.833,
											0.833,
											0.833
										]
									},
									"o": {
										"x": [
											0.167,
											0.167,
											0.167
										],
										"y": [
											0.167,
											0.167,
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167",
										"0p833_0p833_0p167_0p167",
										"0p833_0p833_0p167_0p167"
									],
									"t": 505,
									"s": [
										100,
										0,
										100
									],
									"e": [
										100,
										100,
										100
									]
								},
								{
									"t": 600.000024438501
								}
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													22.671,
													-36.542
												],
												[
													22.671,
													36.542
												],
												[
													-22.671,
													36.542
												],
												[
													-22.671,
													-36.542
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											543.522,
											24.999
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100.008,
											99.193
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 505.000020569072,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 1",
					"td": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 505,
												"s": [
													{
														"i": [
															[
																27.906,
																11.441
															],
															[
																0,
																-40.989
															],
															[
																51.157,
																-31.004
															],
															[
																0,
																40.989
															]
														],
														"o": [
															[
																28.518,
																13.309
															],
															[
																0,
																40.989
															],
															[
																49.321,
																-30.07
															],
															[
																0,
																-40.989
															]
														],
														"v": [
															[
																25.698,
																-65.812
															],
															[
																62.526,
																0
															],
															[
																24.474,
																68.147
															],
															[
																62.292,
																0.467
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																49.933,
																6.305
															],
															[
																0,
																-40.989
															],
															[
																36.56,
																0
															],
															[
																0,
																40.989
															]
														],
														"o": [
															[
																36.56,
																0
															],
															[
																0,
																40.989
															],
															[
																65.841,
																-18.397
															],
															[
																0,
																-40.989
															]
														],
														"v": [
															[
																0,
																-74.217
															],
															[
																66.197,
																0
															],
															[
																0,
																74.217
															],
															[
																42.713,
																0
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											0,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											504.695,
											21.225
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											81.719,
											107.087
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Ellipse 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 505.000020569072,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "C",
					"tt": 2,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 29,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 120.0000048877
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 0,
												"s": [
													{
														"i": [
															[
																29.334,
																0
															],
															[
																0,
																45.541
															],
															[
																-38.156,
																0
															],
															[
																-1.962,
																-18.999
															],
															[
																0,
																0
															],
															[
																34.873,
																-0.007
															],
															[
																0,
																-51.079
															],
															[
																-32.228,
																0.3
															],
															[
																-4.102,
																20.925
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-38.156,
																0
															],
															[
																0,
																-45.951
															],
															[
																35.693,
																0
															],
															[
																0,
																0
															],
															[
																-2.05,
																-19.489
															],
															[
																-33.516,
																0.007
															],
															[
																0,
																51.08
															],
															[
																30.901,
																-0.288
															],
															[
																0,
																0
															],
															[
																-3.692,
																21.54
															]
														],
														"v": [
															[
																4.574,
																72.923
															],
															[
																-59.631,
																-0.029
															],
															[
																4.616,
																-73.089
															],
															[
																57.749,
																-33.626
															],
															[
																57.821,
																-33.626
															],
															[
																4.616,
																-73.069
															],
															[
																-59.592,
																-0.029
															],
															[
																4.574,
																72.85
															],
															[
																60.029,
																33.694
															],
															[
																59.942,
																33.819
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																29.334,
																0
															],
															[
																0,
																45.541
															],
															[
																-38.156,
																0
															],
															[
																-1.025,
																-16.001
															],
															[
																0,
																0
															],
															[
																34.873,
																0
															],
															[
																0,
																-51.079
															],
															[
																-36.104,
																0
															],
															[
																-4.102,
																20.925
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-38.156,
																0
															],
															[
																0,
																-45.951
															],
															[
																35.693,
																0
															],
															[
																0,
																0
															],
															[
																-2.05,
																-19.489
															],
															[
																-36.104,
																0
															],
															[
																0,
																51.08
															],
															[
																33.027,
																0
															],
															[
																0,
																0
															],
															[
																-3.692,
																21.54
															]
														],
														"v": [
															[
																4.616,
																71.798
															],
															[
																-58.568,
																0
															],
															[
																4.616,
																-71.799
															],
															[
																56.515,
																-33.642
															],
															[
																58.977,
																-33.642
															],
															[
																4.616,
																-73.85
															],
															[
																-61.029,
																0
															],
															[
																4.616,
																73.85
															],
															[
																61.029,
																33.643
															],
															[
																58.567,
																33.643
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 120,
												"s": [
													{
														"i": [
															[
																29.334,
																0
															],
															[
																0,
																45.541
															],
															[
																-38.156,
																0
															],
															[
																-1.025,
																-16.001
															],
															[
																0,
																0
															],
															[
																34.873,
																0
															],
															[
																0,
																-51.079
															],
															[
																-36.104,
																0
															],
															[
																-4.102,
																20.925
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-38.156,
																0
															],
															[
																0,
																-45.951
															],
															[
																35.693,
																0
															],
															[
																0,
																0
															],
															[
																-2.05,
																-19.489
															],
															[
																-36.104,
																0
															],
															[
																0,
																51.08
															],
															[
																33.027,
																0
															],
															[
																0,
																0
															],
															[
																-3.692,
																21.54
															]
														],
														"v": [
															[
																4.616,
																71.798
															],
															[
																-58.568,
																0
															],
															[
																4.616,
																-71.799
															],
															[
																56.515,
																-33.642
															],
															[
																58.977,
																-33.642
															],
															[
																4.616,
																-73.85
															],
															[
																-61.029,
																0
															],
															[
																4.616,
																73.85
															],
															[
																61.029,
																33.643
															],
															[
																58.567,
																33.643
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																22.651,
																-0.361
															],
															[
																-0.082,
																34.279
															],
															[
																-21.351,
																-0.31
															],
															[
																-5.165,
																-14.312
															],
															[
																0,
																0
															],
															[
																34.873,
																0
															],
															[
																0,
																-51.079
															],
															[
																-36.104,
																0
															],
															[
																-4.102,
																20.925
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-32.098,
																0.512
															],
															[
																0.11,
																-45.951
															],
															[
																24.901,
																0.362
															],
															[
																0,
																0
															],
															[
																-2.05,
																-19.489
															],
															[
																-36.104,
																0
															],
															[
																0,
																51.08
															],
															[
																33.027,
																0
															],
															[
																0,
																0
															],
															[
																-6.592,
																18.118
															]
														],
														"v": [
															[
																4.574,
																58.423
															],
															[
																-45.193,
																0.033
															],
															[
																4.574,
																-58.799
															],
															[
																42.64,
																-33.626
															],
															[
																58.977,
																-33.642
															],
															[
																4.616,
																-73.85
															],
															[
																-61.029,
																0
															],
															[
																4.616,
																73.85
															],
															[
																61.029,
																33.643
															],
															[
																44.317,
																33.694
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 240,
												"s": [
													{
														"i": [
															[
																22.651,
																-0.361
															],
															[
																-0.082,
																34.279
															],
															[
																-21.351,
																-0.31
															],
															[
																-5.165,
																-14.312
															],
															[
																0,
																0
															],
															[
																34.873,
																0
															],
															[
																0,
																-51.079
															],
															[
																-36.104,
																0
															],
															[
																-4.102,
																20.925
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-32.098,
																0.512
															],
															[
																0.11,
																-45.951
															],
															[
																24.901,
																0.362
															],
															[
																0,
																0
															],
															[
																-2.05,
																-19.489
															],
															[
																-36.104,
																0
															],
															[
																0,
																51.08
															],
															[
																33.027,
																0
															],
															[
																0,
																0
															],
															[
																-6.592,
																18.118
															]
														],
														"v": [
															[
																4.574,
																58.423
															],
															[
																-45.193,
																0.033
															],
															[
																4.574,
																-58.799
															],
															[
																42.64,
																-33.626
															],
															[
																58.977,
																-33.642
															],
															[
																4.616,
																-73.85
															],
															[
																-61.029,
																0
															],
															[
																4.616,
																73.85
															],
															[
																61.029,
																33.643
															],
															[
																44.317,
																33.694
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																12.11,
																-0.018
															],
															[
																-0.087,
																32.088
															],
															[
																-21.353,
																0.025
															],
															[
																-3.165,
																-14.47
															],
															[
																0,
																0
															],
															[
																38.484,
																0.038
															],
															[
																0,
																-51.079
															],
															[
																-36.103,
																0.255
															],
															[
																-2.054,
																25.67
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-9.141,
																0.014
															],
															[
																0.043,
																-15.788
															],
															[
																11.109,
																-0.013
															],
															[
																0,
																0
															],
															[
																-4.002,
																-27.67
															],
															[
																-36.104,
																-0.036
															],
															[
																0,
																51.08
															],
															[
																40.859,
																-0.288
															],
															[
																0,
																0
															],
															[
																-2.092,
																13.14
															]
														],
														"v": [
															[
																4.491,
																37.924
															],
															[
																-21.193,
																0.1
															],
															[
																4.491,
																-38.3
															],
															[
																23.89,
																-19.468
															],
															[
																64.227,
																-19.392
															],
															[
																4.616,
																-73.851
															],
															[
																-61.029,
																0
															],
															[
																4.616,
																73.851
															],
															[
																66.779,
																16.643
															],
															[
																26.067,
																16.672
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 360,
												"s": [
													{
														"i": [
															[
																12.11,
																-0.018
															],
															[
																-0.087,
																32.088
															],
															[
																-21.353,
																0.025
															],
															[
																-3.165,
																-14.47
															],
															[
																0,
																0
															],
															[
																38.484,
																0.038
															],
															[
																0,
																-51.079
															],
															[
																-36.103,
																0.255
															],
															[
																-2.054,
																25.67
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-9.141,
																0.014
															],
															[
																0.043,
																-15.788
															],
															[
																11.109,
																-0.013
															],
															[
																0,
																0
															],
															[
																-4.002,
																-27.67
															],
															[
																-36.104,
																-0.036
															],
															[
																0,
																51.08
															],
															[
																40.859,
																-0.288
															],
															[
																0,
																0
															],
															[
																-2.092,
																13.14
															]
														],
														"v": [
															[
																4.491,
																37.924
															],
															[
																-21.193,
																0.1
															],
															[
																4.491,
																-38.3
															],
															[
																23.89,
																-19.468
															],
															[
																64.227,
																-19.392
															],
															[
																4.616,
																-73.851
															],
															[
																-61.029,
																0
															],
															[
																4.616,
																73.851
															],
															[
																66.779,
																16.643
															],
															[
																26.067,
																16.672
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																1.902,
																0.139
															],
															[
																0.668,
																0.712
															],
															[
																-1.516,
																-0.138
															],
															[
																-0.415,
																-0.22
															],
															[
																0,
																0
															],
															[
																47.612,
																0.106
															],
															[
																0,
																-51.079
															],
															[
																-36.104,
																0.026
															],
															[
																0.946,
																27.42
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-2.843,
																-0.208
															],
															[
																0.343,
																-0.994
															],
															[
																1.234,
																0.112
															],
															[
																0,
																0
															],
															[
																0.248,
																-33.045
															],
															[
																-39.141,
																-0.087
															],
															[
																0,
																51.08
															],
															[
																52.109,
																-0.038
															],
															[
																0,
																0
															],
															[
																0.158,
																0.89
															]
														],
														"v": [
															[
																3.323,
																0.424
															],
															[
																1.807,
																0.6
															],
															[
																3.491,
																0.2
															],
															[
																3.14,
																-0.718
															],
															[
																67.477,
																-0.392
															],
															[
																4.616,
																-73.851
															],
															[
																-63.529,
																0
															],
															[
																4.616,
																73.851
															],
															[
																67.779,
																-0.857
															],
															[
																3.067,
																-0.578
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 505,
												"s": [
													{
														"i": [
															[
																1.902,
																0.139
															],
															[
																0.668,
																0.712
															],
															[
																-1.516,
																-0.138
															],
															[
																-0.415,
																-0.22
															],
															[
																0,
																0
															],
															[
																47.612,
																0.106
															],
															[
																0,
																-51.079
															],
															[
																-36.104,
																0.026
															],
															[
																0.946,
																27.42
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-2.843,
																-0.208
															],
															[
																0.343,
																-0.994
															],
															[
																1.234,
																0.112
															],
															[
																0,
																0
															],
															[
																0.248,
																-33.045
															],
															[
																-39.141,
																-0.087
															],
															[
																0,
																51.08
															],
															[
																52.109,
																-0.038
															],
															[
																0,
																0
															],
															[
																0.158,
																0.89
															]
														],
														"v": [
															[
																3.323,
																0.424
															],
															[
																1.807,
																0.6
															],
															[
																3.491,
																0.2
															],
															[
																3.14,
																-0.718
															],
															[
																67.477,
																-0.392
															],
															[
																4.616,
																-73.851
															],
															[
																-63.529,
																0
															],
															[
																4.616,
																73.851
															],
															[
																67.779,
																-0.857
															],
															[
																3.067,
																-0.578
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																1.902,
																0.139
															],
															[
																0.668,
																0.712
															],
															[
																-1.516,
																-0.138
															],
															[
																-0.415,
																-0.22
															],
															[
																0,
																0
															],
															[
																61.109,
																-0.337
															],
															[
																0,
																-51.079
															],
															[
																-36.093,
																0.892
															],
															[
																0.946,
																27.42
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-2.843,
																-0.208
															],
															[
																0.343,
																-0.994
															],
															[
																1.234,
																0.112
															],
															[
																0,
																0
															],
															[
																8.998,
																-53.795
															],
															[
																-39.141,
																0.216
															],
															[
																0,
																51.08
															],
															[
																72.359,
																-1.788
															],
															[
																0,
																0
															],
															[
																0.158,
																0.89
															]
														],
														"v": [
															[
																3.323,
																0.424
															],
															[
																1.807,
																0.6
															],
															[
																3.491,
																0.2
															],
															[
																16.89,
																38.532
															],
															[
																77.727,
																39.358
															],
															[
																4.616,
																-73.851
															],
															[
																-63.529,
																-0.001
															],
															[
																4.616,
																73.851
															],
															[
																74.529,
																-33.607
															],
															[
																8.067,
																-33.078
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											1075.933,
											333.904
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 2",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 1.00000004073083,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_3",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 2",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"n": "0p833_0p833_0p167_0p167",
									"t": 447,
									"s": [
										1090,
										445,
										0
									],
									"e": [
										1090,
										510,
										0
									],
									"to": [
										0,
										10.8333330154419,
										0
									],
									"ti": [
										0,
										-10.8333330154419,
										0
									]
								},
								{
									"t": 600.000024438501
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													280.625,
													147
												],
												[
													235.5,
													147
												],
												[
													216.25,
													186.75
												],
												[
													283.125,
													186.75
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 447.000018206683,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 3",
					"td": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													418.75,
													-50.25
												],
												[
													327,
													-50.25
												],
												[
													306,
													93
												],
												[
													439,
													93
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 0,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "A",
					"tt": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 31,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 119.000004846969
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																41.288,
																21.141
															],
															[
																-41.342,
																21.141
															],
															[
																-41.277,
																20.827
															],
															[
																0,
																-71.799
															],
															[
																0.02,
																-71.799
															],
															[
																-63.983,
																71.799
															],
															[
																-63.986,
																71.799
															],
															[
																-41.357,
																21.129
															],
															[
																41.233,
																21.129
															],
															[
																63.799,
																71.799
															],
															[
																63.78,
																71.799
															],
															[
																0.042,
																-71.814
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																40.413,
																19.078
															],
															[
																-39.592,
																19.078
															],
															[
																-41.027,
																20.514
															],
															[
																0,
																-71.799
															],
															[
																-2.667,
																-71.799
															],
															[
																-66.67,
																71.799
															],
															[
																-63.798,
																71.799
															],
															[
																-41.232,
																21.129
															],
															[
																41.233,
																21.129
															],
															[
																63.799,
																71.799
															],
															[
																66.671,
																71.799
															],
															[
																2.667,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.198,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																40.413,
																19.078
															],
															[
																-39.592,
																19.078
															],
															[
																-41.027,
																20.514
															],
															[
																0,
																-71.799
															],
															[
																-2.667,
																-71.799
															],
															[
																-66.67,
																71.799
															],
															[
																-63.798,
																71.799
															],
															[
																-41.232,
																21.129
															],
															[
																41.233,
																21.129
															],
															[
																63.799,
																71.799
															],
															[
																66.671,
																71.799
															],
															[
																2.667,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																29.417,
																11.94
															],
															[
																-19.463,
																11.94
															],
															[
																-33.027,
																24.764
															],
															[
																0,
																-71.799
															],
															[
																-17.292,
																-71.814
															],
															[
																-66.67,
																71.799
															],
															[
																-49.423,
																71.757
															],
															[
																-34.482,
																28.004
															],
															[
																34.983,
																28.254
															],
															[
																49.549,
																71.757
															],
															[
																66.671,
																71.799
															],
															[
																17.042,
																-71.814
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.398,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																29.417,
																11.94
															],
															[
																-19.463,
																11.94
															],
															[
																-33.027,
																24.764
															],
															[
																0,
																-71.799
															],
															[
																-17.292,
																-71.814
															],
															[
																-66.67,
																71.799
															],
															[
																-49.423,
																71.757
															],
															[
																-34.482,
																28.004
															],
															[
																34.983,
																28.254
															],
															[
																49.549,
																71.757
															],
															[
																66.671,
																71.799
															],
															[
																17.042,
																-71.814
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																11.177,
																1.539
															],
															[
																0.672,
																1.539
															],
															[
																-16.277,
																39.389
															],
															[
																0,
																-71.799
															],
															[
																-45.792,
																-71.844
															],
															[
																-66.67,
																71.799
															],
															[
																-20.798,
																71.798
															],
															[
																-16.658,
																41.917
															],
															[
																16.932,
																42.167
															],
															[
																21.174,
																71.798
															],
															[
																66.671,
																71.799
															],
															[
																45.792,
																-71.844
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.599,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																11.177,
																1.539
															],
															[
																0.672,
																1.539
															],
															[
																-16.277,
																39.389
															],
															[
																0,
																-71.799
															],
															[
																-45.792,
																-71.844
															],
															[
																-66.67,
																71.799
															],
															[
																-20.798,
																71.798
															],
															[
																-16.658,
																41.917
															],
															[
																16.932,
																42.167
															],
															[
																21.174,
																71.798
															],
															[
																66.671,
																71.799
															],
															[
																45.792,
																-71.844
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0,
																-71.799
															],
															[
																14.071,
																23.039
															],
															[
																0.441,
																23.039
															],
															[
																-18.883,
																60.889
															],
															[
																0,
																-71.799
															],
															[
																-45.792,
																-71.844
															],
															[
																-66.67,
																71.799
															],
															[
																-20.798,
																71.798
															],
															[
																-19.264,
																63.417
															],
															[
																19.826,
																63.667
															],
															[
																21.174,
																71.798
															],
															[
																66.671,
																71.799
															],
															[
																45.792,
																-71.844
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 446.798768198486
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 360,
												"s": [
													0
												],
												"e": [
													28
												]
											},
											{
												"t": 447.000018206683
											}
										]
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											943.107,
											333.904
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 3",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 1.00000004073083,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_4",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 2",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": 0.833,
										"y": 0.833
									},
									"o": {
										"x": 0.167,
										"y": 0.167
									},
									"n": "0p833_0p833_0p167_0p167",
									"t": 434,
									"s": [
										960,
										444.5,
										0
									],
									"e": [
										960,
										540,
										0
									],
									"to": [
										0,
										15.9166669845581,
										0
									],
									"ti": [
										0,
										-15.9166669845581,
										0
									]
								},
								{
									"t": 600.000024438501
								}
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 0,
										"k": {
											"i": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"o": [
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												],
												[
													0,
													0
												]
											],
											"v": [
												[
													283.125,
													144.5
												],
												[
													240.5,
													144.5
												],
												[
													223.75,
													186.75
												],
												[
													283.125,
													186.75
												]
											],
											"c": true
										}
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 480.000019550801,
					"op": 900.000036657752,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "Shape Layer 1",
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								975.25,
								541,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								74.614,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 360,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-79.034,
																-5.367
															],
															[
																-79.034,
																5.016
															],
															[
																-79.216,
																5.191
															],
															[
																-79.216,
																-5.191
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																182.156,
																-5.117
															],
															[
																182.156,
																5.266
															],
															[
																-79.216,
																5.191
															],
															[
																-79.216,
																-5.191
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											358.716,
											87.191
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Rectangle 1",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 360.000014663101,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "F",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 29,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 119.000004846969
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-55.351,
																71.784
															],
															[
																-55.326,
																71.836
															],
															[
																-55.326,
																4.854
															],
															[
																43.918,
																4.817
															],
															[
																43.856,
																4.827
															],
															[
																-55.31,
																4.827
															],
															[
																-55.326,
																4.755
															],
															[
																-55.451,
																-70.71
															],
															[
																56.289,
																-70.747
															],
															[
																56.467,
																-70.674
															],
															[
																-55.297,
																-70.689
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.413,
																71.799
															],
															[
																-53.951,
																71.799
															],
															[
																-53.951,
																5.129
															],
															[
																44.106,
																5.129
															],
															[
																44.106,
																3.077
															],
															[
																-52.31,
																3.077
															],
															[
																-53.951,
																4.718
															],
															[
																-53.951,
																-69.747
															],
															[
																56.414,
																-69.747
															],
															[
																56.414,
																-71.799
															],
															[
																-56.413,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.198,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.413,
																71.799
															],
															[
																-53.951,
																71.799
															],
															[
																-53.951,
																5.129
															],
															[
																44.106,
																5.129
															],
															[
																44.106,
																3.077
															],
															[
																-52.31,
																3.077
															],
															[
																-53.951,
																4.718
															],
															[
																-53.951,
																-69.747
															],
															[
																56.414,
																-69.747
															],
															[
																56.414,
																-71.799
															],
															[
																-56.413,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.413,
																71.799
															],
															[
																-39.701,
																71.882
															],
															[
																-39.754,
																12.087
															],
															[
																44.053,
																12.004
															],
															[
																44.053,
																-4.048
															],
															[
																-25.738,
																-4.008
															],
															[
																-39.654,
																9.801
															],
															[
																-39.811,
																-55.414
															],
															[
																56.304,
																-55.497
															],
															[
																56.414,
																-71.799
															],
															[
																-56.413,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.398,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.413,
																71.799
															],
															[
																-39.701,
																71.882
															],
															[
																-39.754,
																12.087
															],
															[
																44.053,
																12.004
															],
															[
																44.053,
																-4.048
															],
															[
																-25.738,
																-4.008
															],
															[
																-39.654,
																9.801
															],
															[
																-39.811,
																-55.414
															],
															[
																56.304,
																-55.497
															],
															[
																56.414,
																-71.799
															],
															[
																-56.413,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.413,
																71.799
															],
															[
																-14.951,
																71.798
															],
															[
																-15.108,
																25.003
															],
															[
																43.949,
																25.004
															],
															[
																43.949,
																-18.548
															],
															[
																-1.092,
																-18.592
															],
															[
																-14.966,
																22.967
															],
															[
																-15.029,
																-30.998
															],
															[
																56.336,
																-30.997
															],
															[
																56.414,
																-71.799
															],
															[
																-56.413,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.599,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.413,
																71.799
															],
															[
																-14.951,
																71.798
															],
															[
																-15.108,
																25.003
															],
															[
																43.949,
																25.004
															],
															[
																43.949,
																-18.548
															],
															[
																-1.092,
																-18.592
															],
															[
																-14.966,
																22.967
															],
															[
																-15.029,
																-30.998
															],
															[
																56.336,
																-30.997
															],
															[
																56.414,
																-71.799
															],
															[
																-56.413,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-56.413,
																71.799
															],
															[
																56.799,
																71.88
															],
															[
																56.376,
																60.542
															],
															[
																43.072,
																60.118
															],
															[
																42.99,
																17.014
															],
															[
																-14.051,
																16.932
															],
															[
																55.912,
																71.718
															],
															[
																56.649,
																63.084
															],
															[
																56.264,
																63.003
															],
															[
																56.414,
																-71.799
															],
															[
																-56.413,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 434.000017677182
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											809.768,
											333.903
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 4",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 1.00000004073083,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_5",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "R",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 31,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 120.0000048877
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.622,
																-25.414
															],
															[
																35.272,
																-0.117
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																33.833,
																-0.615
															],
															[
																-0.62,
																25.317
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-60.064,
																9.305
															],
															[
																-60.205,
																8.858
															],
															[
																-60.318,
																-70.71
															],
															[
																-0.603,
																-70.747
															],
															[
																51.199,
																-31.136
															],
															[
																-0.49,
																9.305
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-25.027
															],
															[
																33.233,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																33.233,
																0
															],
															[
																0,
																26.052
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-57.439,
																7.18
															],
															[
																-59.08,
																8.821
															],
															[
																-59.08,
																-69.747
															],
															[
																-0.615,
																-69.747
															],
															[
																48.824,
																-31.386
															],
															[
																-0.615,
																7.18
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.198,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-25.027
															],
															[
																33.233,
																0
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																33.233,
																0
															],
															[
																0,
																26.052
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-57.439,
																7.18
															],
															[
																-59.08,
																8.821
															],
															[
																-59.08,
																-69.747
															],
															[
																-0.615,
																-69.747
															],
															[
																48.824,
																-31.386
															],
															[
																-0.615,
																7.18
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.027,
																-15.324
															],
															[
																25.363,
																-0.117
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																21.238,
																0.051
															],
															[
																-0.04,
																23.129
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-29.962,
																0.394
															],
															[
																-44.955,
																14.983
															],
															[
																-44.978,
																-55.21
															],
															[
																0.862,
																-55.488
															],
															[
																35.574,
																-31.363
															],
															[
																-0.638,
																0.43
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.398,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.027,
																-15.324
															],
															[
																25.363,
																-0.117
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																21.238,
																0.051
															],
															[
																-0.04,
																23.129
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-29.962,
																0.394
															],
															[
																-44.955,
																14.983
															],
															[
																-44.978,
																-55.21
															],
															[
																0.862,
																-55.488
															],
															[
																35.574,
																-31.363
															],
															[
																-0.638,
																0.43
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.027,
																-4.425
															],
															[
																13.534,
																-0.509
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																8.534,
																-0.199
															],
															[
																0.027,
																4.425
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-3.757,
																-7.178
															],
															[
																-21.068,
																34.75
															],
															[
																-21.017,
																-31.381
															],
															[
																0.823,
																-31.676
															],
															[
																11.387,
																-20.113
															],
															[
																-2.183,
																-7.178
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.599,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.027,
																-4.425
															],
															[
																13.534,
																-0.509
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																8.534,
																-0.199
															],
															[
																0.027,
																4.425
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-3.757,
																-7.178
															],
															[
																-21.068,
																34.75
															],
															[
																-21.017,
																-31.381
															],
															[
																0.823,
																-31.676
															],
															[
																11.387,
																-20.113
															],
															[
																-2.183,
																-7.178
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.31,
																-5.907
															],
															[
																9.624,
																-0.34
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																5.509,
																0.24
															],
															[
																0.17,
																3.244
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-14.511,
																-18.086
															],
															[
																-21.085,
																34.667
															],
															[
																-21.017,
																-31.381
															],
															[
																-13.659,
																-31.696
															],
															[
																-5.57,
																-25.432
															],
															[
																-14.273,
																-18.723
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 414,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.31,
																-5.907
															],
															[
																9.624,
																-0.34
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																5.509,
																0.24
															],
															[
																0.17,
																3.244
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-14.511,
																-18.086
															],
															[
																-21.085,
																34.667
															],
															[
																-21.017,
																-31.381
															],
															[
																-13.659,
																-31.696
															],
															[
																-5.57,
																-25.432
															],
															[
																-14.273,
																-18.723
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.084,
																-4.592
															],
															[
																4.436,
																0.239
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.44,
																-0.261
															],
															[
																0.084,
																4.033
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-22.237,
																-16.666
															],
															[
																-22.641,
																26.923
															],
															[
																-21.017,
																-31.381
															],
															[
																-19.589,
																-31.551
															],
															[
																-13.609,
																-26.471
															],
															[
																-22.211,
																-22.302
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 443,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.084,
																-4.592
															],
															[
																4.436,
																0.239
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																4.44,
																-0.261
															],
															[
																0.084,
																4.033
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-22.237,
																-16.666
															],
															[
																-22.641,
																26.923
															],
															[
																-21.017,
																-31.381
															],
															[
																-19.589,
																-31.551
															],
															[
																-13.609,
																-26.471
															],
															[
																-22.211,
																-22.302
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																8.923,
																0.219
															],
															[
																24.284,
																-0.259
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.723,
																5.488
															],
															[
																-3.036,
																-0.075
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-40.007,
																-8.178
															],
															[
																-31.068,
																-15
															],
															[
																-21.017,
																-31.381
															],
															[
																-20.427,
																-33.176
															],
															[
																-25.863,
																-40.113
															],
															[
																-65.183,
																-41.678
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																24.001
															],
															[
																32.823,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																32.823,
																0
															],
															[
																0,
																-23.796
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																2.667,
																9.231
															],
															[
																51.285,
																-31.386
															],
															[
																2.676,
																-70.674
															],
															[
																-60.283,
																-70.716
															],
															[
																-60.292,
																71.757
															],
															[
																-60.33,
																71.831
															],
															[
																-60.205,
																9.268
															],
															[
																-1.042,
																9.189
															],
															[
																59.68,
																71.757
															],
															[
																59.792,
																71.814
															],
															[
																-1,
																9.246
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																24.001
															],
															[
																32.823,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																32.823,
																0
															],
															[
																0,
																-23.796
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																2.667,
																9.231
															],
															[
																51.285,
																-31.386
															],
															[
																2.667,
																-71.799
															],
															[
																-61.542,
																-71.799
															],
															[
																-61.542,
																71.799
															],
															[
																-59.08,
																71.799
															],
															[
																-59.08,
																9.231
															],
															[
																-2.667,
																9.231
															],
															[
																58.055,
																71.799
															],
															[
																61.542,
																71.799
															],
															[
																0,
																9.231
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.198,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																0,
																24.001
															],
															[
																32.823,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																32.823,
																0
															],
															[
																0,
																-23.796
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																2.667,
																9.231
															],
															[
																51.285,
																-31.386
															],
															[
																2.667,
																-71.799
															],
															[
																-61.542,
																-71.799
															],
															[
																-61.542,
																71.799
															],
															[
																-59.08,
																71.799
															],
															[
																-59.08,
																9.231
															],
															[
																-2.667,
																9.231
															],
															[
																58.055,
																71.799
															],
															[
																61.542,
																71.799
															],
															[
																0,
																9.231
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																-0.059,
																31.074
															],
															[
																28.184,
																-0.639
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																26.758,
																-0.433
															],
															[
																0.046,
																-24.177
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																7.592,
																15.746
															],
															[
																51.16,
																-30.761
															],
															[
																4.417,
																-71.799
															],
															[
																-61.542,
																-71.799
															],
															[
																-61.542,
																71.799
															],
															[
																-44.717,
																71.757
															],
															[
																-44.78,
																15.939
															],
															[
																-14.492,
																15.996
															],
															[
																39.18,
																71.757
															],
															[
																61.542,
																71.799
															],
															[
																7.05,
																15.996
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.398,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																-0.059,
																31.074
															],
															[
																28.184,
																-0.639
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																26.758,
																-0.433
															],
															[
																0.046,
																-24.177
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																7.592,
																15.746
															],
															[
																51.16,
																-30.761
															],
															[
																4.417,
																-71.799
															],
															[
																-61.542,
																-71.799
															],
															[
																-61.542,
																71.799
															],
															[
																-44.717,
																71.757
															],
															[
																-44.78,
																15.939
															],
															[
																-14.492,
																15.996
															],
															[
																39.18,
																71.757
															],
															[
																61.542,
																71.799
															],
															[
																7.05,
																15.996
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																-0.309,
																38.949
															],
															[
																28.184,
																-0.639
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																11.696,
																-7.433
															],
															[
																0.192,
																-24.176
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																23.78,
																30.496
															],
															[
																51.41,
																-21.636
															],
															[
																4.417,
																-71.799
															],
															[
																-61.542,
																-71.799
															],
															[
																-61.542,
																71.799
															],
															[
																-20.217,
																71.676
															],
															[
																-20.217,
																40.108
															],
															[
																-20.242,
																37.496
															],
															[
																-4.07,
																71.798
															],
															[
																61.542,
																71.799
															],
															[
																23.55,
																30.746
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.599,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																-0.309,
																38.949
															],
															[
																28.184,
																-0.639
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																11.696,
																-7.433
															],
															[
																0.192,
																-24.176
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																23.78,
																30.496
															],
															[
																51.41,
																-21.636
															],
															[
																4.417,
																-71.799
															],
															[
																-61.542,
																-71.799
															],
															[
																-61.542,
																71.799
															],
															[
																-20.217,
																71.676
															],
															[
																-20.217,
																40.108
															],
															[
																-20.242,
																37.496
															],
															[
																-4.07,
																71.798
															],
															[
																61.542,
																71.799
															],
															[
																23.55,
																30.746
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																4.191,
																38.698
															],
															[
																34.684,
																-0.139
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-1.929,
																-15.684
															],
															[
																-2.603,
																-24.037
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																59.28,
																47.996
															],
															[
																53.91,
																1.864
															],
															[
																13.917,
																-71.564
															],
															[
																-61.542,
																-71.799
															],
															[
																-61.542,
																71.799
															],
															[
																-20.217,
																71.676
															],
															[
																61.783,
																71.608
															],
															[
																146.758,
																-71.004
															],
															[
																-68.237,
																72.125
															],
															[
																61.542,
																71.799
															],
															[
																59.05,
																48.246
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											681.557,
											333.904
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 5",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 1.00000004073083,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_6",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "P",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 32,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 120.0000048877
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																33.643,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.046,
																-26.852
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																35.194,
																-1.44
															],
															[
																0.046,
																27.284
															]
														],
														"v": [
															[
																3.837,
																12.158
															],
															[
																-54.81,
																12.533
															],
															[
																-55.202,
																13.049
															],
															[
																-55.202,
																-70.497
															],
															[
																2.462,
																-70.622
															],
															[
																54.827,
																-29.335
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																33.643,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-26.463
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																33.643,
																0
															],
															[
																0,
																27.284
															]
														],
														"v": [
															[
																2.462,
																11.283
															],
															[
																-52.31,
																11.283
															],
															[
																-53.952,
																12.924
															],
															[
																-53.952,
																-69.747
															],
															[
																2.462,
																-69.747
															],
															[
																53.952,
																-29.335
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.198,
												"s": [
													{
														"i": [
															[
																33.643,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-26.463
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																33.643,
																0
															],
															[
																0,
																27.284
															]
														],
														"v": [
															[
																2.462,
																11.283
															],
															[
																-52.31,
																11.283
															],
															[
																-53.952,
																12.924
															],
															[
																-53.952,
																-69.747
															],
															[
																2.462,
																-69.747
															],
															[
																53.952,
																-29.335
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																16.819,
																0.405
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.079,
																-22.102
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																17.391,
																-0.065
															],
															[
																-0.098,
																27.284
															]
														],
														"v": [
															[
																1.962,
																3.783
															],
															[
																-25.185,
																3.783
															],
															[
																-39.998,
																18.32
															],
															[
																-39.96,
																-55.914
															],
															[
																2.515,
																-55.872
															],
															[
																40.202,
																-27.835
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.398,
												"s": [
													{
														"i": [
															[
																16.819,
																0.405
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.079,
																-22.102
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																17.391,
																-0.065
															],
															[
																-0.098,
																27.284
															]
														],
														"v": [
															[
																1.962,
																3.783
															],
															[
																-25.185,
																3.783
															],
															[
																-39.998,
																18.32
															],
															[
																-39.96,
																-55.914
															],
															[
																2.515,
																-55.872
															],
															[
																40.202,
																-27.835
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																8.819,
																-0.095
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.046,
																-3.477
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.783,
																-0.19
															],
															[
																0.041,
																3.149
															]
														],
														"v": [
															[
																6.712,
																-8.592
															],
															[
																1.315,
																-8.4
															],
															[
																-15.404,
																32.36
															],
															[
																-15.353,
																-31.623
															],
															[
																2.623,
																-31.622
															],
															[
																15.702,
																-19.96
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.599,
												"s": [
													{
														"i": [
															[
																8.819,
																-0.095
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.046,
																-3.477
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																12.783,
																-0.19
															],
															[
																0.041,
																3.149
															]
														],
														"v": [
															[
																6.712,
																-8.592
															],
															[
																1.315,
																-8.4
															],
															[
																-15.404,
																32.36
															],
															[
																-15.353,
																-31.623
															],
															[
																2.623,
																-31.622
															],
															[
																15.702,
																-19.96
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																3.278,
																0.055
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.012,
																-4.627
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																2.583,
																-0.165
															],
															[
																0.238,
																4.873
															]
														],
														"v": [
															[
																-14.372,
																-1.367
															],
															[
																-14.844,
																5.967
															],
															[
																-15.433,
																50.094
															],
															[
																-15.819,
																-11.556
															],
															[
																-12.177,
																-11.772
															],
															[
																-6.332,
																-6.56
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 416,
												"s": [
													{
														"i": [
															[
																3.278,
																0.055
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.012,
																-4.627
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																2.583,
																-0.165
															],
															[
																0.238,
																4.873
															]
														],
														"v": [
															[
																-14.372,
																-1.367
															],
															[
																-14.844,
																5.967
															],
															[
																-15.433,
																50.094
															],
															[
																-15.819,
																-11.556
															],
															[
																-12.177,
																-11.772
															],
															[
																-6.332,
																-6.56
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																1.319,
																6.03
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.079,
																-0.727
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.033,
																-0.065
															],
															[
																-0.332,
																3.006
															]
														],
														"v": [
															[
																-15.538,
																-92.467
															],
															[
																-16.435,
																10.6
															],
															[
																17.784,
																64.61
															],
															[
																-15.103,
																-4.873
															],
															[
																-14.252,
																-4.747
															],
															[
																-13.049,
																-3.71
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																33.912,
																-1.013
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.008,
																25.648
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																33.412,
																-0.396
															],
															[
																0.007,
																-25.027
															]
														],
														"v": [
															[
																5.743,
																-70.549
															],
															[
																-55.163,
																-70.591
															],
															[
																-55.163,
																71.757
															],
															[
																-55.202,
																71.924
															],
															[
																-55.202,
																12.334
															],
															[
																5.743,
																12.209
															],
															[
																54.789,
																-29.335
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																34.259,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																25.233
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																34.259,
																0
															],
															[
																0,
																-25.027
															]
														],
														"v": [
															[
																5.743,
																-71.799
															],
															[
																-56.413,
																-71.799
															],
															[
																-56.413,
																71.799
															],
															[
																-53.952,
																71.799
															],
															[
																-53.952,
																13.334
															],
															[
																5.743,
																13.334
															],
															[
																56.414,
																-29.335
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.198,
												"s": [
													{
														"i": [
															[
																34.259,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																25.233
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																34.259,
																0
															],
															[
																0,
																-25.027
															]
														],
														"v": [
															[
																5.743,
																-71.799
															],
															[
																-56.413,
																-71.799
															],
															[
																-56.413,
																71.799
															],
															[
																-53.952,
																71.799
															],
															[
																-53.952,
																13.334
															],
															[
																5.743,
																13.334
															],
															[
																56.414,
																-29.335
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																34.259,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																25.233
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																39.389,
																-0.521
															],
															[
																0,
																-25.027
															]
														],
														"v": [
															[
																6.172,
																-71.924
															],
															[
																-56.36,
																-72.049
															],
															[
																-56.413,
																71.799
															],
															[
																-40.014,
																71.757
															],
															[
																-39.991,
																20.167
															],
															[
																5.767,
																20.209
															],
															[
																56.789,
																-27.335
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.398,
												"s": [
													{
														"i": [
															[
																34.259,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																25.233
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																39.389,
																-0.521
															],
															[
																0,
																-25.027
															]
														],
														"v": [
															[
																6.172,
																-71.924
															],
															[
																-56.36,
																-72.049
															],
															[
																-56.413,
																71.799
															],
															[
																-40.014,
																71.757
															],
															[
																-39.991,
																20.167
															],
															[
																5.767,
																20.209
															],
															[
																56.789,
																-27.335
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																34.259,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.008,
																27.523
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																46.264,
																-0.521
															],
															[
																0.007,
																-25.027
															]
														],
														"v": [
															[
																6.172,
																-71.924
															],
															[
																-56.36,
																-72.049
															],
															[
																-56.413,
																71.799
															],
															[
																-15.514,
																71.798
															],
															[
																-15.397,
																34.458
															],
															[
																5.267,
																34.459
															],
															[
																56.789,
																-27.335
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.599,
												"s": [
													{
														"i": [
															[
																34.259,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.008,
																27.523
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																46.264,
																-0.521
															],
															[
																0.007,
																-25.027
															]
														],
														"v": [
															[
																6.172,
																-71.924
															],
															[
																-56.36,
																-72.049
															],
															[
																-56.413,
																71.799
															],
															[
																-15.514,
																71.798
															],
															[
																-15.397,
																34.458
															],
															[
																5.267,
																34.459
															],
															[
																56.789,
																-27.335
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																34.259,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.008,
																27.523
															]
														],
														"o": [
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.014,
																-5.896
															],
															[
																0.007,
																-25.027
															]
														],
														"v": [
															[
																6.172,
																-71.924
															],
															[
																-56.36,
																-72.049
															],
															[
																-56.413,
																71.799
															],
															[
																200.861,
																71.63
															],
															[
																199.478,
																-125.667
															],
															[
																57.142,
																-5.791
															],
															[
																56.789,
																-27.335
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											409.752,
											333.903
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 1",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 1.00000004073083,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_7",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "U",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 29,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 120.0000048877
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.34,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 1,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																32.026,
																-0.568
															],
															[
																-0.381,
																43.087
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.139,
																0.522
															],
															[
																-0.09,
																44.843
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0.559,
																42.658
															],
															[
																-32.045,
																0.568
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0.431,
																45.487
															],
															[
																32.139,
																-0.522
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																55.326,
																11.077
															],
															[
																0.063,
																71.835
															],
															[
																-55.326,
																11.099
															],
															[
																-55.326,
																-72.803
															],
															[
																-55.351,
																-72.824
															],
															[
																-55.351,
																9.847
															],
															[
																0,
																71.824
															],
															[
																55.413,
																9.909
															],
															[
																55.413,
																-72.762
															],
															[
																55.326,
																-72.824
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																31.591,
																0
															],
															[
																0,
																42.464
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																0,
																45.746
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																42.464
															],
															[
																-31.592,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																45.746
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																53.952,
																11.077
															],
															[
																0,
																70.772
															],
															[
																-53.951,
																11.077
															],
															[
																-53.951,
																-72.824
															],
															[
																-56.413,
																-72.824
															],
															[
																-56.413,
																9.846
															],
															[
																0,
																72.824
															],
															[
																56.413,
																9.846
															],
															[
																56.413,
																-72.824
															],
															[
																53.952,
																-72.824
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 119.246,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																31.591,
																0
															],
															[
																0,
																42.464
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																0,
																45.746
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0,
																42.464
															],
															[
																-31.592,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																45.746
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																53.952,
																11.077
															],
															[
																0,
																70.772
															],
															[
																-53.951,
																11.077
															],
															[
																-53.951,
																-72.824
															],
															[
																-56.413,
																-72.824
															],
															[
																-56.413,
																9.846
															],
															[
																0,
																72.824
															],
															[
																56.413,
																9.846
															],
															[
																56.413,
																-72.824
															],
															[
																53.952,
																-72.824
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																31.591,
																0
															],
															[
																0.199,
																21.098
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																-0.416,
																43.69
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-0.454,
																21.848
															],
															[
																-31.592,
																0
															],
															[
																-0.199,
																-21.098
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.089,
																41.69
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																39.952,
																11.189
															],
															[
																0.091,
																56.272
															],
															[
																-39.951,
																11.189
															],
															[
																-39.951,
																-73.213
															],
															[
																-56.413,
																-73.324
															],
															[
																-56.413,
																9.846
															],
															[
																0,
																72.824
															],
															[
																56.413,
																9.846
															],
															[
																56.413,
																-73.324
															],
															[
																39.952,
																-73.213
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 239.498,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																31.591,
																0
															],
															[
																0.199,
																21.098
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																-0.416,
																43.69
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-0.454,
																21.848
															],
															[
																-31.592,
																0
															],
															[
																-0.199,
																-21.098
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.089,
																41.69
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																39.952,
																11.189
															],
															[
																0.091,
																56.272
															],
															[
																-39.951,
																11.189
															],
															[
																-39.951,
																-73.213
															],
															[
																-56.413,
																-73.324
															],
															[
																-56.413,
																9.846
															],
															[
																0,
																72.824
															],
															[
																56.413,
																9.846
															],
															[
																56.413,
																-73.324
															],
															[
																39.952,
																-73.213
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																7.101,
																0.014
															],
															[
																0.449,
																20.625
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																-0.416,
																43.69
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-0.454,
																21.375
															],
															[
																-8.527,
																-0.017
															],
															[
																-0.459,
																-21.094
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.089,
																41.69
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																15.202,
																11.162
															],
															[
																0.084,
																32.897
															],
															[
																-15.201,
																11.162
															],
															[
																-15.201,
																-73.24
															],
															[
																-56.413,
																-73.324
															],
															[
																-56.413,
																11.846
															],
															[
																0,
																72.824
															],
															[
																56.413,
																11.846
															],
															[
																56.413,
																-73.324
															],
															[
																15.202,
																-73.24
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359.749,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																7.101,
																0.014
															],
															[
																0.449,
																20.625
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																-0.416,
																43.69
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-0.454,
																21.375
															],
															[
																-8.527,
																-0.017
															],
															[
																-0.459,
																-21.094
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.089,
																41.69
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																15.202,
																11.162
															],
															[
																0.084,
																32.897
															],
															[
																-15.201,
																11.162
															],
															[
																-15.201,
																-73.24
															],
															[
																-56.413,
																-73.324
															],
															[
																-56.413,
																11.846
															],
															[
																0,
																72.824
															],
															[
																56.413,
																11.846
															],
															[
																56.413,
																-73.324
															],
															[
																15.202,
																-73.24
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																3.47,
																-0.034
															],
															[
																0.052,
																2.272
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																-0.416,
																43.69
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0.063,
																4.772
															],
															[
																-4.406,
																0.044
															],
															[
																-0.555,
																-5.875
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.089,
																41.69
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																3.934,
																-49.485
															],
															[
																0.029,
																-43.132
															],
															[
																-4.054,
																-49.485
															],
															[
																-4.443,
																-73.146
															],
															[
																-56.413,
																-73.324
															],
															[
																-56.413,
																11.847
															],
															[
																0,
																72.824
															],
															[
																56.413,
																11.847
															],
															[
																56.413,
																-73.324
															],
															[
																4.443,
																-73.146
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 446,
												"s": [
													{
														"i": [
															[
																0,
																0
															],
															[
																3.47,
																-0.034
															],
															[
																0.052,
																2.272
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																-0.416,
																43.69
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																0.063,
																4.772
															],
															[
																-4.406,
																0.044
															],
															[
																-0.555,
																-5.875
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.089,
																41.69
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																3.934,
																-49.485
															],
															[
																0.029,
																-43.132
															],
															[
																-4.054,
																-49.485
															],
															[
																-4.443,
																-73.146
															],
															[
																-56.413,
																-73.324
															],
															[
																-56.413,
																11.847
															],
															[
																0,
																72.824
															],
															[
																56.413,
																11.847
															],
															[
																56.413,
																-73.324
															],
															[
																4.443,
																-73.146
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																0
															],
															[
																-0.156,
																0.169
															],
															[
																-0.192,
																0.973
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-32.617,
																0
															],
															[
																-0.416,
																43.69
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-0.055,
																0.522
															],
															[
																-0.281,
																0.169
															],
															[
																0.058,
																0.348
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																-0.089,
																41.69
															],
															[
																32.617,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																0.428,
																-72.485
															],
															[
																0.647,
																-72.257
															],
															[
																0.564,
																-73.187
															],
															[
																0.182,
																-73.097
															],
															[
																-56.413,
																-73.324
															],
															[
																-56.413,
																11.846
															],
															[
																0,
																72.824
															],
															[
																56.413,
																11.846
															],
															[
																56.413,
																-73.324
															],
															[
																0.193,
																-73.132
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 480.000019550801
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											276.413,
											334.929
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 8",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 1.00000004073083,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				}
			]
		},
		{
			"id": "comp_8",
			"layers": [
				{
					"ddd": 0,
					"ind": 1,
					"ty": 4,
					"nm": "Shape Layer 1",
					"td": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								960,
								540,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 538,
												"s": [
													{
														"i": [
															[
																25.5,
																2.75
															],
															[
																-19,
																-1.75
															]
														],
														"o": [
															[
																17.75,
																1
															],
															[
																-14,
																-1.5
															]
														],
														"v": [
															[
																-476.75,
																16.5
															],
															[
																-440.5,
																20
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																43,
																-3.75
															],
															[
																-19,
																-1.75
															]
														],
														"o": [
															[
																17.75,
																1
															],
															[
																0,
																-13.75
															]
														],
														"v": [
															[
																-447.75,
																-21.5
															],
															[
																-389.75,
																-14.5
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 601.000024479232
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ind": 1,
									"ty": "sh",
									"ix": 2,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 538,
												"s": [
													{
														"i": [
															[
																4.25,
																1
															],
															[
																-8.73,
																-1.898
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.25,
																-1
															],
															[
																11.5,
																2.5
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-473.25,
																56
															],
															[
																-443,
																62.25
															],
															[
																-430.75,
																65
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																4.25,
																1
															],
															[
																-8.5,
																-2.75
															],
															[
																0,
																0
															]
														],
														"o": [
															[
																-4.25,
																-1
															],
															[
																22.394,
																7.245
															],
															[
																0,
																0
															]
														],
														"v": [
															[
																-473.25,
																56
															],
															[
																-464.25,
																69.5
															],
															[
																-429.75,
																64.75
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 601.000024479232
											}
										]
									},
									"nm": "Path 2",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											0,
											0,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Shape 1",
							"np": 4,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 538.000021913189,
					"op": 1260.00005132085,
					"st": 360.000014663101,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 2,
					"ty": 4,
					"nm": "S 2",
					"tt": 2,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 479.598,
												"s": [
													{
														"i": [
															[
																0.723,
																-5.481
															],
															[
																2.318,
																-7.26
															],
															[
																30.378,
																0.462
															],
															[
																4.062,
																23.881
															],
															[
																0,
																0
															],
															[
																0.12,
																1.059
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																8.606
															],
															[
																-30.745,
																-0.312
															],
															[
																-10.123,
																-15.617
															],
															[
																0,
																0
															],
															[
																0.08,
																-3.764
															]
														],
														"o": [
															[
																-2.189,
																16.596
															],
															[
																-5.065,
																15.863
															],
															[
																-35.119,
																-0.535
															],
															[
																0,
																0
															],
															[
																-0.4,
																-5.084
															],
															[
																-0.295,
																-2.612
															],
															[
																-0.346,
																-10.346
															],
															[
																8.058,
																-25.421
															],
															[
																24.512,
																0.248
															],
															[
																10.123,
																15.617
															],
															[
																0.408,
																6.189
															],
															[
																-0.234,
																11.043
															]
														],
														"v": [
															[
																55.399,
																18.09
															],
															[
																51.266,
																38.822
															],
															[
																0.206,
																73.6
															],
															[
																-58.603,
																28.431
															],
															[
																-61.141,
																14.021
															],
															[
																-61.371,
																5.424
															],
															[
																-61.32,
																-1.592
															],
															[
																-57.688,
																-33.544
															],
															[
																0.206,
																-74.225
															],
															[
																45.102,
																-51.376
															],
															[
																55.423,
																-18.877
															],
															[
																56.007,
																-1.674
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.723,
																-5.482
															],
															[
																4.305,
																-6.288
															],
															[
																30.38,
																0.293
															],
															[
																1.005,
																15.222
															],
															[
																0,
																0
															],
															[
																-0.067,
																-19.265
															],
															[
																22.446,
																28.216
															],
															[
																-0.086,
																-35.053
															],
															[
																-82.238,
																0.166
															],
															[
																-10.123,
																-15.617
															],
															[
																0,
																0
															],
															[
																-0.688,
																-8.1
															]
														],
														"o": [
															[
																-2.189,
																16.596
															],
															[
																-6.107,
																8.919
															],
															[
																-70.257,
																-0.677
															],
															[
																0,
																0
															],
															[
																2.527,
																19.384
															],
															[
																-88.309,
																-14.126
															],
															[
																-10.784,
																41.268
															],
															[
																0.72,
																0.696
															],
															[
																24.513,
																-0.05
															],
															[
																10.123,
																15.617
															],
															[
																0.408,
																6.189
															],
															[
																1.261,
																14.849
															]
														],
														"v": [
															[
																55.399,
																18.09
															],
															[
																39.037,
																51.841
															],
															[
																0.206,
																73.6
															],
															[
																-62.973,
																-47.812
															],
															[
																51.785,
																-33.157
															],
															[
																59.209,
																55.985
															],
															[
																-59.343,
																-16.345
															],
															[
																-69.293,
																58.474
															],
															[
																0.208,
																-73.225
															],
															[
																43.853,
																-50.624
															],
															[
																53.421,
																-19.874
															],
															[
																55.257,
																-1.673
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											143.074,
											333.904
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0.09,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 480.000019550801,
					"op": 959.000039060871,
					"st": 59.0000024031193,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 3,
					"ty": 4,
					"nm": "mate 1",
					"td": 1,
					"ks": {
						"o": {
							"a": 0,
							"k": 100
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								390.5,
								228,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ind": 0,
							"ty": "sh",
							"ix": 1,
							"ks": {
								"a": 1,
								"k": [
									{
										"i": {
											"x": 0.833,
											"y": 0.833
										},
										"o": {
											"x": 0.167,
											"y": 0.167
										},
										"n": "0p833_0p833_0p167_0p167",
										"t": 437,
										"s": [
											{
												"i": [
													[
														-0.112,
														17.378
													],
													[
														1.751,
														15.911
													],
													[
														5.061,
														7.808
													],
													[
														7.832,
														3.729
													],
													[
														12.256,
														0.124
													],
													[
														9.686,
														-5.844
													],
													[
														4.029,
														-12.711
													],
													[
														0.487,
														-13.087
													],
													[
														0.141,
														-8.413
													],
													[
														-11.063,
														-8.412
													],
													[
														-17.559,
														-0.268
													],
													[
														-11.348,
														8.403
													]
												],
												"o": [
													[
														0.017,
														-2.764
													],
													[
														-1.751,
														-15.911
													],
													[
														-5.061,
														-7.808
													],
													[
														-7.832,
														-3.729
													],
													[
														-15.373,
														-0.156
													],
													[
														-9.686,
														5.844
													],
													[
														-1.364,
														4.303
													],
													[
														-0.487,
														13.087
													],
													[
														-0.217,
														12.912
													],
													[
														11.064,
														8.412
													],
													[
														15.189,
														0.231
													],
													[
														11.348,
														-8.403
													]
												],
												"v": [
													[
														203.973,
														356.744
													],
													[
														201.759,
														323.419
													],
													[
														191.926,
														282.528
													],
													[
														172.999,
														265.34
													],
													[
														143.28,
														259.679
													],
													[
														105.7,
														267.995
													],
													[
														85.136,
														295.61
													],
													[
														82.492,
														325.06
													],
													[
														81.683,
														360.675
													],
													[
														99.149,
														393.573
													],
													[
														143.28,
														407.504
													],
													[
														184.935,
														395.331
													]
												],
												"c": true
											}
										],
										"e": [
											{
												"i": [
													[
														-2.189,
														16.596
													],
													[
														-0.234,
														11.043
													],
													[
														0.408,
														6.189
													],
													[
														10.123,
														15.617
													],
													[
														24.512,
														0.248
													],
													[
														8.058,
														-25.421
													],
													[
														-0.346,
														-10.345
													],
													[
														-0.295,
														-2.612
													],
													[
														-0.4,
														-5.084
													],
													[
														0,
														0
													],
													[
														-35.119,
														-0.535
													],
													[
														-5.065,
														15.863
													]
												],
												"o": [
													[
														0.723,
														-5.481
													],
													[
														0.08,
														-3.764
													],
													[
														0,
														0
													],
													[
														-10.123,
														-15.617
													],
													[
														-30.745,
														-0.312
													],
													[
														-2.728,
														8.606
													],
													[
														-0.221,
														4.779
													],
													[
														0.12,
														1.059
													],
													[
														0,
														0
													],
													[
														4.062,
														23.881
													],
													[
														30.378,
														0.462
													],
													[
														2.318,
														-7.26
													]
												],
												"v": [
													[
														198.473,
														351.994
													],
													[
														199.08,
														332.229
													],
													[
														198.497,
														315.027
													],
													[
														188.176,
														282.528
													],
													[
														143.28,
														259.679
													],
													[
														85.386,
														300.36
													],
													[
														81.754,
														332.312
													],
													[
														81.703,
														339.328
													],
													[
														81.933,
														347.925
													],
													[
														84.471,
														362.335
													],
													[
														143.28,
														407.504
													],
													[
														194.34,
														372.726
													]
												],
												"c": true
											}
										]
									},
									{
										"t": 479.00001951007
									}
								]
							},
							"nm": "Path 1",
							"mn": "ADBE Vector Shape - Group"
						},
						{
							"ty": "fl",
							"c": {
								"a": 0,
								"k": [
									1,
									0,
									0,
									1
								]
							},
							"o": {
								"a": 0,
								"k": 100
							},
							"r": 1,
							"nm": "Fill 1",
							"mn": "ADBE Vector Graphic - Fill"
						}
					],
					"ip": 359.00001462237,
					"op": 900.000036657751,
					"st": 0,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 4,
					"ty": 4,
					"nm": "S",
					"tt": 1,
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 31,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 119.000004846969
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 2,
												"s": [
													{
														"i": [
															[
																-0.292,
																-25.205
															],
															[
																1.365,
																-53.253
															],
															[
																32.839,
																-0.82
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.655,
																0.803
															],
															[
																0.464,
																25.368
															],
															[
																-0.122,
																55.193
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																35.112,
																0.456
															]
														],
														"o": [
															[
																0.637,
																54.923
															],
															[
																-0.684,
																26.682
															],
															[
																-33.838,
																0.845
															],
															[
																0,
																0
															],
															[
																-0.446,
																29.89
															],
															[
																31.469,
																-0.798
															],
															[
																-0.992,
																-54.194
															],
															[
																0.059,
																-26.668
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																0.39,
																-19.626
															],
															[
																-29.512,
																-0.383
															]
														],
														"v": [
															[
																-56.039,
																-34.97
															],
															[
																59.391,
																32.949
															],
															[
																0.142,
																72.663
															],
															[
																-59.516,
																31.242
															],
															[
																-59.554,
																31.308
															],
															[
																0.145,
																72.674
															],
															[
																59.43,
																33.31
															],
															[
																-56.001,
																-34.984
															],
															[
																0.193,
																-72.912
															],
															[
																54.201,
																-33.625
															],
															[
																54.239,
																-33.629
															],
															[
																0.19,
																-72.924
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																-23.591
															],
															[
																0,
																-54.977
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.592,
																0
															],
															[
																0,
																24.822
															],
															[
																0,
																55.798
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																34.668,
																0
															]
														],
														"o": [
															[
																0,
																53.952
															],
															[
																0,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																0,
																28.309
															],
															[
																31.181,
																0
															],
															[
																0,
																-53.131
															],
															[
																0,
																-26.668
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-19.078
															],
															[
																-29.335,
																0
															]
														],
														"v": [
															[
																-54.977,
																-35.284
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-58.054,
																31.181
															],
															[
																0.206,
																71.799
															],
															[
																58.055,
																33.437
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																52.926,
																-33.643
															],
															[
																0.206,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 116.383,
												"s": [
													{
														"i": [
															[
																0,
																-23.591
															],
															[
																0,
																-54.977
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.592,
																0
															],
															[
																0,
																24.822
															],
															[
																0,
																55.798
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																34.668,
																0
															]
														],
														"o": [
															[
																0,
																53.952
															],
															[
																0,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																0,
																28.309
															],
															[
																31.181,
																0
															],
															[
																0,
																-53.131
															],
															[
																0,
																-26.668
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-19.078
															],
															[
																-29.335,
																0
															]
														],
														"v": [
															[
																-54.977,
																-35.284
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-58.054,
																31.181
															],
															[
																0.206,
																71.799
															],
															[
																58.055,
																33.437
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																52.926,
																-33.643
															],
															[
																0.206,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.197,
																-19.283
															],
															[
																-0.182,
																-57.76
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.588,
																-0.5
															],
															[
																0.404,
																20.154
															],
															[
																0.522,
																57.856
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																20.955,
																-0.014
															]
														],
														"o": [
															[
																-0.439,
																42.971
															],
															[
																0.087,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																1.888,
																18.131
															],
															[
																16.628,
																0.263
															],
															[
																-0.346,
																-40.846
															],
															[
																-0.241,
																-26.667
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																-2.592,
																-16.936
															],
															[
																-20.955,
																0.014
															]
														],
														"v": [
															[
																-41.102,
																-35.534
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-44.804,
																31.181
															],
															[
																0.706,
																57.799
															],
															[
																43.43,
																33.408
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																38.551,
																-33.627
															],
															[
																0.254,
																-59.549
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 238.793,
												"s": [
													{
														"i": [
															[
																0.197,
																-19.283
															],
															[
																-0.182,
																-57.76
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.588,
																-0.5
															],
															[
																0.404,
																20.154
															],
															[
																0.522,
																57.856
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																20.955,
																-0.014
															]
														],
														"o": [
															[
																-0.439,
																42.971
															],
															[
																0.087,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																1.888,
																18.131
															],
															[
																16.628,
																0.263
															],
															[
																-0.346,
																-40.846
															],
															[
																-0.241,
																-26.667
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																-2.592,
																-16.936
															],
															[
																-20.955,
																0.014
															]
														],
														"v": [
															[
																-41.102,
																-35.534
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-44.804,
																31.181
															],
															[
																0.706,
																57.799
															],
															[
																43.43,
																33.408
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																38.551,
																-33.627
															],
															[
																0.254,
																-59.549
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359,
												"s": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 480,
												"s": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.723,
																-5.482
															],
															[
																4.305,
																-6.288
															],
															[
																30.38,
																0.293
															],
															[
																1.005,
																15.222
															],
															[
																0,
																0
															],
															[
																-0.067,
																-19.265
															],
															[
																22.446,
																28.216
															],
															[
																-0.086,
																-35.053
															],
															[
																-82.238,
																0.166
															],
															[
																-10.123,
																-15.617
															],
															[
																0,
																0
															],
															[
																-0.688,
																-8.1
															]
														],
														"o": [
															[
																-2.189,
																16.596
															],
															[
																-6.107,
																8.919
															],
															[
																-70.257,
																-0.677
															],
															[
																0,
																0
															],
															[
																2.527,
																19.384
															],
															[
																-88.309,
																-14.126
															],
															[
																-10.784,
																41.268
															],
															[
																0.72,
																0.696
															],
															[
																24.513,
																-0.05
															],
															[
																10.123,
																15.617
															],
															[
																0.408,
																6.189
															],
															[
																1.261,
																14.849
															]
														],
														"v": [
															[
																55.399,
																18.09
															],
															[
																39.037,
																51.841
															],
															[
																0.206,
																73.6
															],
															[
																-62.973,
																-47.812
															],
															[
																51.785,
																-33.157
															],
															[
																59.209,
																55.985
															],
															[
																-59.343,
																-16.345
															],
															[
																-69.293,
																58.474
															],
															[
																0.208,
																-73.225
															],
															[
																43.853,
																-50.624
															],
															[
																53.421,
																-19.874
															],
															[
																55.257,
																-1.673
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "st",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"w": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 359,
												"s": [
													0
												],
												"e": [
													23
												]
											},
											{
												"i": {
													"x": [
														0.833
													],
													"y": [
														0.833
													]
												},
												"o": {
													"x": [
														0.167
													],
													"y": [
														0.167
													]
												},
												"n": [
													"0p833_0p833_0p167_0p167"
												],
												"t": 479,
												"s": [
													23
												],
												"e": [
													48
												]
											},
											{
												"t": 480.000019550801
											}
										]
									},
									"lc": 1,
									"lj": 1,
									"ml": 4,
									"nm": "Stroke 1",
									"mn": "ADBE Vector Graphic - Stroke"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											143.074,
											333.904
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0.09,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 3,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 359.00001462237,
					"op": 481.000019591532,
					"st": 59.0000024031193,
					"bm": 0,
					"sr": 1
				},
				{
					"ddd": 0,
					"ind": 5,
					"ty": 4,
					"nm": "S 3",
					"ks": {
						"o": {
							"a": 1,
							"k": [
								{
									"i": {
										"x": [
											0.833
										],
										"y": [
											0.833
										]
									},
									"o": {
										"x": [
											0.167
										],
										"y": [
											0.167
										]
									},
									"n": [
										"0p833_0p833_0p167_0p167"
									],
									"t": 31,
									"s": [
										0
									],
									"e": [
										100
									]
								},
								{
									"t": 119.000004846969
								}
							]
						},
						"r": {
							"a": 0,
							"k": 0
						},
						"p": {
							"a": 0,
							"k": [
								389.592,
								227.534,
								0
							]
						},
						"a": {
							"a": 0,
							"k": [
								0,
								0,
								0
							]
						},
						"s": {
							"a": 0,
							"k": [
								100,
								100,
								100
							]
						}
					},
					"ao": 0,
					"shapes": [
						{
							"ty": "gr",
							"it": [
								{
									"ind": 0,
									"ty": "sh",
									"ix": 1,
									"ks": {
										"a": 1,
										"k": [
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 2,
												"s": [
													{
														"i": [
															[
																-0.292,
																-25.205
															],
															[
																1.365,
																-53.253
															],
															[
																32.839,
																-0.82
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.655,
																0.803
															],
															[
																0.464,
																25.368
															],
															[
																-0.122,
																55.193
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																35.112,
																0.456
															]
														],
														"o": [
															[
																0.637,
																54.923
															],
															[
																-0.684,
																26.682
															],
															[
																-33.838,
																0.845
															],
															[
																0,
																0
															],
															[
																-0.446,
																29.89
															],
															[
																31.469,
																-0.798
															],
															[
																-0.992,
																-54.194
															],
															[
																0.059,
																-26.668
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																0.39,
																-19.626
															],
															[
																-29.512,
																-0.383
															]
														],
														"v": [
															[
																-56.039,
																-34.97
															],
															[
																59.391,
																32.949
															],
															[
																0.142,
																72.663
															],
															[
																-59.516,
																31.242
															],
															[
																-59.554,
																31.308
															],
															[
																0.145,
																72.674
															],
															[
																59.43,
																33.31
															],
															[
																-56.001,
																-34.984
															],
															[
																0.193,
																-72.912
															],
															[
																54.201,
																-33.625
															],
															[
																54.239,
																-33.629
															],
															[
																0.19,
																-72.924
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0,
																-23.591
															],
															[
																0,
																-54.977
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.592,
																0
															],
															[
																0,
																24.822
															],
															[
																0,
																55.798
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																34.668,
																0
															]
														],
														"o": [
															[
																0,
																53.952
															],
															[
																0,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																0,
																28.309
															],
															[
																31.181,
																0
															],
															[
																0,
																-53.131
															],
															[
																0,
																-26.668
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-19.078
															],
															[
																-29.335,
																0
															]
														],
														"v": [
															[
																-54.977,
																-35.284
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-58.054,
																31.181
															],
															[
																0.206,
																71.799
															],
															[
																58.055,
																33.437
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																52.926,
																-33.643
															],
															[
																0.206,
																-71.799
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 116.383,
												"s": [
													{
														"i": [
															[
																0,
																-23.591
															],
															[
																0,
																-54.977
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.592,
																0
															],
															[
																0,
																24.822
															],
															[
																0,
																55.798
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																34.668,
																0
															]
														],
														"o": [
															[
																0,
																53.952
															],
															[
																0,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																0,
																28.309
															],
															[
																31.181,
																0
															],
															[
																0,
																-53.131
															],
															[
																0,
																-26.668
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																0,
																-19.078
															],
															[
																-29.335,
																0
															]
														],
														"v": [
															[
																-54.977,
																-35.284
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-58.054,
																31.181
															],
															[
																0.206,
																71.799
															],
															[
																58.055,
																33.437
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																52.926,
																-33.643
															],
															[
																0.206,
																-71.799
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.197,
																-19.283
															],
															[
																-0.182,
																-57.76
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.588,
																-0.5
															],
															[
																0.404,
																20.154
															],
															[
																0.522,
																57.856
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																20.955,
																-0.014
															]
														],
														"o": [
															[
																-0.439,
																42.971
															],
															[
																0.087,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																1.888,
																18.131
															],
															[
																16.628,
																0.263
															],
															[
																-0.346,
																-40.846
															],
															[
																-0.241,
																-26.667
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																-2.592,
																-16.936
															],
															[
																-20.955,
																0.014
															]
														],
														"v": [
															[
																-41.102,
																-35.534
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-44.804,
																31.181
															],
															[
																0.706,
																57.799
															],
															[
																43.43,
																33.408
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																38.551,
																-33.627
															],
															[
																0.254,
																-59.549
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 238.793,
												"s": [
													{
														"i": [
															[
																0.197,
																-19.283
															],
															[
																-0.182,
																-57.76
															],
															[
																33.437,
																0
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-31.588,
																-0.5
															],
															[
																0.404,
																20.154
															],
															[
																0.522,
																57.856
															],
															[
																-28.31,
																0
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																20.955,
																-0.014
															]
														],
														"o": [
															[
																-0.439,
																42.971
															],
															[
																0.087,
																27.694
															],
															[
																-33.849,
																0
															],
															[
																0,
																0
															],
															[
																1.888,
																18.131
															],
															[
																16.628,
																0.263
															],
															[
																-0.346,
																-40.846
															],
															[
																-0.241,
																-26.667
															],
															[
																36.719,
																0
															],
															[
																0,
																0
															],
															[
																-2.592,
																-16.936
															],
															[
																-20.955,
																0.014
															]
														],
														"v": [
															[
																-41.102,
																-35.534
															],
															[
																60.516,
																32.822
															],
															[
																0.206,
																73.85
															],
															[
																-60.516,
																31.181
															],
															[
																-44.804,
																31.181
															],
															[
																0.706,
																57.799
															],
															[
																43.43,
																33.408
															],
															[
																-57.438,
																-34.669
															],
															[
																0.206,
																-73.85
															],
															[
																55.388,
																-33.643
															],
															[
																38.551,
																-33.627
															],
															[
																0.254,
																-59.549
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 359,
												"s": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												]
											},
											{
												"i": {
													"x": 0.833,
													"y": 0.833
												},
												"o": {
													"x": 0.167,
													"y": 0.167
												},
												"n": "0p833_0p833_0p167_0p167",
												"t": 480,
												"s": [
													{
														"i": [
															[
																0.102,
																-5.528
															],
															[
																2.977,
																-62.946
															],
															[
																33.436,
																0.274
															],
															[
																0,
																29.54
															],
															[
																0,
																0
															],
															[
																-8.673,
																0.076
															],
															[
																-0.221,
																4.779
															],
															[
																-2.728,
																64.481
															],
															[
																-30.747,
																-0.03
															],
															[
																0,
																-19.488
															],
															[
																0,
																0
															],
															[
																9.83,
																-0.139
															]
														],
														"o": [
															[
																-0.314,
																17.096
															],
															[
																-1.182,
																24.99
															],
															[
																-35.122,
																-0.288
															],
															[
																0,
																0
															],
															[
																2.1,
																9.916
															],
															[
																12.705,
																-0.112
															],
															[
																-0.096,
																-17.846
															],
															[
																1.127,
																-26.644
															],
															[
																38.378,
																0.037
															],
															[
																0,
																0
															],
															[
																-2.092,
																-6.561
															],
															[
																-11.044,
																0.156
															]
														],
														"v": [
															[
																-15.102,
																-29.534
															],
															[
																61.766,
																30.072
															],
															[
																0.206,
																73.6
															],
															[
																-60.478,
																24.681
															],
															[
																-19.766,
																24.646
															],
															[
																1.254,
																37.049
															],
															[
																19.68,
																27.658
															],
															[
																-56.688,
																-32.294
															],
															[
																0.206,
																-74.225
															],
															[
																55.888,
																-28.393
															],
															[
																14.551,
																-28.502
															],
															[
																-1.621,
																-38.674
															]
														],
														"c": true
													}
												],
												"e": [
													{
														"i": [
															[
																0.723,
																-5.482
															],
															[
																4.305,
																-6.288
															],
															[
																30.38,
																0.293
															],
															[
																1.005,
																15.222
															],
															[
																0,
																0
															],
															[
																-0.067,
																-19.265
															],
															[
																22.446,
																28.216
															],
															[
																-0.086,
																-35.053
															],
															[
																-82.238,
																0.166
															],
															[
																-10.123,
																-15.617
															],
															[
																0,
																0
															],
															[
																-0.688,
																-8.1
															]
														],
														"o": [
															[
																-2.189,
																16.596
															],
															[
																-6.107,
																8.919
															],
															[
																-70.257,
																-0.677
															],
															[
																0,
																0
															],
															[
																2.527,
																19.384
															],
															[
																-88.309,
																-14.126
															],
															[
																-10.784,
																41.268
															],
															[
																0.72,
																0.696
															],
															[
																24.513,
																-0.05
															],
															[
																10.123,
																15.617
															],
															[
																0.408,
																6.189
															],
															[
																1.261,
																14.849
															]
														],
														"v": [
															[
																55.399,
																18.09
															],
															[
																39.037,
																51.841
															],
															[
																0.206,
																73.6
															],
															[
																-62.973,
																-47.812
															],
															[
																51.785,
																-33.157
															],
															[
																59.209,
																55.985
															],
															[
																-59.343,
																-16.345
															],
															[
																-69.293,
																58.474
															],
															[
																0.208,
																-73.225
															],
															[
																43.853,
																-50.624
															],
															[
																53.421,
																-19.874
															],
															[
																55.257,
																-1.673
															]
														],
														"c": true
													}
												]
											},
											{
												"t": 600.000024438501
											}
										]
									},
									"nm": "Path 1",
									"mn": "ADBE Vector Shape - Group"
								},
								{
									"ty": "fl",
									"c": {
										"a": 0,
										"k": [
											1,
											1,
											1,
											1
										]
									},
									"o": {
										"a": 0,
										"k": 100
									},
									"r": 1,
									"nm": "Fill 1",
									"mn": "ADBE Vector Graphic - Fill"
								},
								{
									"ty": "tr",
									"p": {
										"a": 0,
										"k": [
											143.074,
											333.904
										],
										"ix": 2
									},
									"a": {
										"a": 0,
										"k": [
											0,
											0
										],
										"ix": 1
									},
									"s": {
										"a": 0,
										"k": [
											100,
											100
										],
										"ix": 3
									},
									"r": {
										"a": 0,
										"k": 0.09,
										"ix": 6
									},
									"o": {
										"a": 0,
										"k": 100,
										"ix": 7
									},
									"sk": {
										"a": 0,
										"k": 0,
										"ix": 4
									},
									"sa": {
										"a": 0,
										"k": 0,
										"ix": 5
									},
									"nm": "Transform"
								}
							],
							"nm": "Group 9",
							"np": 2,
							"cix": 2,
							"ix": 1,
							"mn": "ADBE Vector Group"
						}
					],
					"ip": 2.00000008146167,
					"op": 360.000014663101,
					"st": 59.0000024031193,
					"bm": 0,
					"sr": 1
				}
			]
		}
	],
	"layers": [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 0,
			"nm": "_typo",
			"refId": "comp_0",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						960,
						540,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						817,
						327.5,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"tm": {
				"a": 1,
				"k": [
					{
						"i": {
							"x": [
								0.833
							],
							"y": [
								0.967
							]
						},
						"o": {
							"x": [
								0.333
							],
							"y": [
								0
							]
						},
						"n": [
							"0p833_0p967_0p333_0"
						],
						"t": 360,
						"s": [
							12.012
						],
						"e": [
							1.268
						]
					},
					{
						"t": 720.000029326201
					}
				]
			},
			"w": 1634,
			"h": 655,
			"ip": 360.000014663101,
			"op": 720.000029326201,
			"st": 322.000013115329,
			"bm": 0,
			"sr": 1
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 0,
			"nm": "_typo",
			"refId": "comp_0",
			"ks": {
				"o": {
					"a": 0,
					"k": 100
				},
				"r": {
					"a": 0,
					"k": 0
				},
				"p": {
					"a": 0,
					"k": [
						960,
						540,
						0
					]
				},
				"a": {
					"a": 0,
					"k": [
						817,
						327.5,
						0
					]
				},
				"s": {
					"a": 0,
					"k": [
						100,
						100,
						100
					]
				}
			},
			"ao": 0,
			"tm": {
				"a": 1,
				"k": [
					{
						"i": {
							"x": [
								0.667
							],
							"y": [
								1
							]
						},
						"o": {
							"x": [
								0.167
							],
							"y": [
								0.033
							]
						},
						"n": [
							"0p667_1_0p167_0p033"
						],
						"t": 0,
						"s": [
							1.268
						],
						"e": [
							12.012
						]
					},
					{
						"t": 360.000014663101
					}
				]
			},
			"w": 1634,
			"h": 655,
			"ip": 0,
			"op": 361.000014703831,
			"st": -38.0000015477717,
			"bm": 0,
			"sr": 1
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/json/superface.json
// module id = 502
// module chunks = 0